import { FC, ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../store/context/login";
import { routeMap } from "../utils/constants";

export type ManagerRouteProps = {
  children: ReactElement;
};

/**
 * Gates a route to staff (MANAGER/ADMIN of at least one property). Owners who
 * type the URL directly land back on Home instead of reaching the page, so
 * hiding the sidebar link isn't the only thing standing in the way.
 */
const ManagerRoute: FC<ManagerRouteProps> = ({ children }) => {
  const { user, access } = useAuth();

  if (!access) {
    return <Navigate to={routeMap.login} replace />;
  }
  // get-profile still in flight and nothing cached: hold rather than bounce a
  // manager to Home before their role is known.
  if (!user) {
    return null;
  }
  return user.is_manager ? children : <Navigate to={routeMap.home} replace />;
};

export default ManagerRoute;
